import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from '../../misc/ErrorBoundary';
import I18nWrap from '../../i18n/I18nWrap';
import Main from './Main';

const ProfileImageEditor = ({
  _submitImgHandler,
  error,
  imgSrc,
  locale,
}) => (
  <I18nWrap locale={locale}>
    <ErrorBoundary>
      <Main
        _submitImgHandler={_submitImgHandler}
        error={error}
        imgSrc={imgSrc}
      />
    </ErrorBoundary>
  </I18nWrap>
);

ProfileImageEditor.propTypes = {
  /** Accepts argument of Base 64 encoded image data */
  _submitImgHandler: PropTypes.func.isRequired,
  error: PropTypes.bool,
  imgSrc: PropTypes.string.isRequired,
  locale: PropTypes.string,
};

ProfileImageEditor.defaultProps = {
  error: false,
  locale: 'en',
};

export default ProfileImageEditor;
